var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAiFillBtn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 71,
    viewBox: "0 0 155 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_910_104)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 117,
    height: 33,
    rx: 16.5,
    fill: "url(#paint0_linear_910_104)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.5,
    y: 19.5,
    width: 116,
    height: 32,
    rx: 16,
    stroke: "url(#paint1_linear_910_104)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.032 41L61.048 29.336H64.024L68.04 41H65.848L64.968 38.44H60.104L59.24 41H57.032ZM60.616 36.808H64.472L63.32 33.528L62.584 31.272H62.504L61.752 33.528L60.616 36.808ZM68.8301 31.288V29.336H70.8301V31.288H68.8301ZM68.8301 41V32.488H70.8301V41H68.8301ZM76.1028 41V29.336H84.4068V31.16H78.2148V34.488H83.7668V36.216H78.2148V41H76.1028ZM85.5889 31.288V29.336H87.5889V31.288H85.5889ZM85.5889 41V32.488H87.5889V41H85.5889ZM89.4251 41V29.336H91.4251V41H89.4251ZM93.2614 41V29.336H95.2614V41H93.2614Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_910_104",
    x: 0.130169,
    y: 0.130169,
    width: 154.74,
    height: 70.7397,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.224641
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.356863 0 0 0 0 0.254902 0 0 0 0 0.384314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_910_104"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.449282
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.356863 0 0 0 0 0.254902 0 0 0 0 0.384314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_910_104",
    result: "effect2_dropShadow_910_104"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57249
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.356863 0 0 0 0 0.254902 0 0 0 0 0.384314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_910_104",
    result: "effect3_dropShadow_910_104"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.14497
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.356863 0 0 0 0 0.254902 0 0 0 0 0.384314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_910_104",
    result: "effect4_dropShadow_910_104"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.39138
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.356863 0 0 0 0 0.254902 0 0 0 0 0.384314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_910_104",
    result: "effect5_dropShadow_910_104"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.43492
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.356863 0 0 0 0 0.254902 0 0 0 0 0.384314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_910_104",
    result: "effect6_dropShadow_910_104"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_910_104",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_910_104",
    x1: 19,
    y1: 35.5,
    x2: 136,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#371D5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#6826AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#7028B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E1386"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_910_104",
    x1: 19,
    y1: 35.5,
    x2: 136,
    y2: 35.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9036FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E31FF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAiFillBtn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ai-fill-btn.524fd4ef7aeb5a3a34a3d4486fb0d225.svg";